// extracted by mini-css-extract-plugin
export default {"container":"TextPrimary_container__EXiJl","strong":"TextPrimary_strong__DJLFQ"};